import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface NavFavoritesState {
  favorites: string[]
  toggleFavorite: (key: string) => void
  isFavorite: (key: string) => boolean
}

export const useNavFavoritesStore = create<NavFavoritesState>()(
  persist(
    (set, get) => ({
      favorites: [],
      toggleFavorite: (key) =>
        set((state) => ({
          favorites: state.favorites.includes(key)
            ? state.favorites.filter((k) => k !== key)
            : [...state.favorites, key],
        })),
      isFavorite: (key) => get().favorites.includes(key),
    }),
    { name: 'th-nav-favorites' },
  ),
)
